import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { BubbleBase } from "./BubbleBase";
import { BubbleDiv } from "./BubbleDiv";
export var Bubble = /*#__PURE__*/function (_BubbleBase) {
  _inherits(Bubble, _BubbleBase);
  var _super = _createSuper(Bubble);
  function Bubble() {
    _classCallCheck(this, Bubble);
    return _super.apply(this, arguments);
  }
  _createClass(Bubble, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(Bubble.prototype), "load", this).call(this, data);
      if (!(data !== undefined && data.divs !== undefined)) {
        return;
      }
      if (data.divs instanceof Array) {
        this.divs = data.divs.map(function (s) {
          var tmp = new BubbleDiv();
          tmp.load(s);
          return tmp;
        });
      } else {
        if (this.divs instanceof Array || !this.divs) {
          this.divs = new BubbleDiv();
        }
        this.divs.load(data.divs);
      }
    }
  }]);
  return Bubble;
}(BubbleBase);